import { Component, OnInit, HostListener, EventEmitter, Output, ChangeDetectorRef, ViewChild, Input, SimpleChanges } from '@angular/core';
import { SideNavServiceService } from '../services/side-nav-service.service';
import { LoginService } from '../services/login.service';
import { NavigationService } from '../services/navigation.service';
import { JobService } from '../services/jobs/job.service';
import { LearnerService } from '../services/learner.service';
import { MatMenuTrigger } from '@angular/material/menu';
import * as _ from 'lodash';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment.prod';

@Component({
  selector: 'app-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss']
})



export class TopNavComponent implements OnInit {

  loggedInUser;
  currentUser;
  user: any;
  role: any;
  learnerJob = []
  displayDropdown = false
  selectedIndex
  selectedJob
  jobId
  versionNumber = environment
  @Output() btnClicked: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('clickHoverMenuTrigger', { static: true }) clickHoverMenuTrigger: MatMenuTrigger;
  @Input('job') singleJob
  constructor(
    public routingState: NavigationService,
    public sideNavService: SideNavServiceService,
    public _loginService: LoginService,
    public _change: ChangeDetectorRef,
    public jobService: JobService,
    public learnerService: LearnerService,
    private activatedRoute: ActivatedRoute,
    private route: Router,
    public cd: ChangeDetectorRef
  ) {

    this._loginService.userToken.subscribe(res => {
      this.loggedInUser = res;
    })

    this._loginService.userProfile.subscribe(res => {
      this.currentUser = res;
      this.loggedInUser = res;
      // console.log("_loginService.userProfile _loginService.userProfile", JSON.parse(res))
      this.ngOnInit()
    })
    routingState.loadRouting();


    this.activatedRoute.queryParams.subscribe(params => {
      console.log("PARAS IN CONSTUCTOR ==========>", params);
      if (params && params.job) {
        this.jobId = params.job
      }
      // this.learnerId = params.id;
    })

  }
  openMenu() {
    this.sideNavService.open();
  }



  menuOpen() {
    console.log("event of menu open", this.selectedJob, this.learnerJob);

    console.log("=====================", this.activatedRoute.snapshot.params);

    console.log("what is the current url", this.route.url);


    this.activatedRoute.queryParams.subscribe(qparams => {
      console.log("what is value of query params", qparams);
      let jobId = qparams.job
      let index = _.findIndex(this.learnerJob, function (o) {
        console.log("what is the job id", o);
        // console.log("selected job data", this.selectedJob);

        return (JSON.stringify(o._id) == JSON.stringify(jobId));
      })


      console.log("find indx data", index);

      if (index > -1) {
        $("#folder_card_" + index).addClass('selectedBorder')
      } else {
        let x = this.route.url.split('=')
        console.log("what is x factor", x);
        let jobId = x[1]
        let index1 = _.findIndex(this.learnerJob, function (o) {
          console.log("what is the job id", o);
          return (JSON.stringify(o._id) == JSON.stringify(jobId));
        })
        $("#folder_card_" + index1).addClass('selectedBorder')

      }

    })




  }


  emitEvent(value) {
    console.log("what is in this vaslue", value);

    console.log("current user value", this.currentUser);
    let obj = {}
    obj['value'] = value
    console.log("user role data", this.user);
    if (this.user && this.user.isAdmin) {
      obj['userId'] = this.currentUser._id
    } else {
      obj['userId'] = this.currentUser.userId
    }

    this.btnClicked.emit(obj)
  }

  ngOnInit() {
    console.log("NG ON ININT CALLDE")
    this.loggedInUser = localStorage.getItem("currentUser");
    console.log('this.loggedInUser', this.loggedInUser)
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    console.log('this.currentUser', this.currentUser)
    this.role = this.currentUser ? this.currentUser.userRole[0] : ''
    console.log('this.role', this.role)
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    this.cd.detectChanges()
    console.log("login user role value", this.user);

    if (this.user == 'isStaff') {
      this.role = 'staff'
    }

    if (this.user == 'isLearner') {
      this.role = 'learner'
    }
    console.log("USers data ==> role in top nav", this.role);
    // this._change.detectChanges();
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes.singleJob && changes.singleJob.currentValue) {
      this.jobId = changes.singleJob.currentValue
    }
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(e) {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      $(".topnav").addClass("transitionEffect")
      document.getElementById("sideBar").style.paddingTop = "70px";
    } else {
      $(".topnav").removeClass("transitionEffect")
      document.getElementById("sideBar").style.paddingTop = "60px";
    }
  }
  jobDetails(job, index) {
    console.log("single job details", job);
    this.selectedIndex = index
    this.learnerService.singleJob(job._id)
  }

}
